import React from 'react';

import css from './NotificationCard.module.css';

const defaultIconSrc = `${process.env.PUBLIC_URL}/rpry-icon.svg`;

/**
 * Single notification preference row: brand icon, title, custom checkbox.
 * The whole row acts as a label for the checkbox (click anywhere to toggle).
 */
const NotificationCard = ({
  inputId,
  label,
  value,
  checked,
  onScopeChange,
  registerInput,
  iconSrc = defaultIconSrc,
  successHighlight = false,
}) => {
  const { onChange: registerOnChange, ...registerRest } = registerInput;

  return (
    <label
      className={[
        css.card,
        successHighlight ? css.cardSuccess : '',
      ].filter(Boolean).join(' ')}
      htmlFor={inputId}
    >
      <span className={css.iconWrap} aria-hidden="true">
        <img
          className={css.icon}
          src={iconSrc}
          alt=""
        />
      </span>
      <span className={css.title}>{label}</span>
      <span className={css.checkboxSlot}>
        <input
          id={inputId}
          type="checkbox"
          className={css.nativeInput}
          value={value}
          checked={checked}
          {...registerRest}
          onChange={(e) => {
            registerOnChange(e);
            onScopeChange(e);
          }}
        />
        <span className={css.checkboxFace} aria-hidden="true" />
      </span>
    </label>
  );
};

export default NotificationCard;
